import { GET_ROLES, SUCCESS, FAIL } from "../action_types";

const STATE_INIT = {
  isLoading: false,
  isUpdating: false,
  roles: [],
  error: {},
};

export default (state = STATE_INIT, { type, payload }) => {
  switch (type) {
    case GET_ROLES:
      return { ...state, isLoading: true };
    case `${GET_ROLES}_${SUCCESS}`:
      return {
        ...state,
        isLoading: false,
        roles: [...payload],
      };
    case `${GET_ROLES}_${FAIL}`:
      return { ...state, isLoading: false, error: { ...payload } };

    default:
      return state;
  }
};
